import React, { Component } from 'react';

import 'styles/placeholder.css';
import './clickCollectPlaceholder.styles.scss';

export default class ClickCollectPlaceholder extends Component {
    render() {
        return (
            <div className="clickcollect-placeholder">
                <div className="clickcollect-placeholder__row">
                    <div className="clickcollect-placeholder__label placeholder__item">
                        <div className="placeholder__animation" />
                    </div>
                </div>
                <div className="clickcollect-placeholder__row">
                    <div className="clickcollect-placeholder__input placeholder__item">
                        <div className="placeholder__animation" />
                    </div>
                </div>
            </div>
        );
    }
}
